import React from "react";
import { Row, Col } from "reactstrap";
import DesignCard from "../DesignCard";
import get from "lodash/get";

const _ = { get };

const RidesReportsDetailPage = ({ rowData, elements }) => {
  return (
    <React.Fragment>
      {rowData ? (
        <div className="hideSearch my-3 px-3">
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.branchCodeElement",
                  "Branch Code"
                )}
                titleName={rowData.branchCode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.branchNameElement",
                  "Branch Name"
                )}
                titleName={rowData.branchName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideCountryElement",
                  "Ride Country"
                )}
                titleName={rowData.rideCountry}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideStateElement",
                  "Ride State"
                )}
                titleName={rowData.rideState}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideCityElement",
                  "Ride City"
                )}
                titleName={rowData.rideCity}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.moderationStatusElement",
                  "Moderation Status"
                )}
                titleName={rowData.moderationStatus}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideStartDateElement",
                  "Ride Start Date"
                )}
                titleName={rowData.rideStartDate}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideEndDateElement",
                  "Ride End Date"
                )}
                titleName={rowData.rideEndDate}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideStatusElement",
                  "Ride Status"
                )}
                titleName={rowData.rideStatus}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.rideLevelElement",
                  "Ride Level"
                )}
                titleName={rowData.rideLevel}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "ridesReportsDetailElement.allocatedRideCountElement",
                  "Allocated Ride Count"
                )}
                titleName={rowData.allocatedRiderCount}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <h5 className="text-center font-weight-bold">
          {_.get(
            elements,
            "ridesReportsDetailElement.noUserFoundElement",
            "No user found"
          )}
        </h5>
      )}
    </React.Fragment>
  );
};

export default RidesReportsDetailPage;
